import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {

    constructor(private api: ApiService) { }

    list(params: any = {}): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.api.get(`hr/employee/list${queryString ? '?' + queryString : ''}`);
    }

    create(payload: any): Observable<any> {
        return this.api.post('hr/employee/add', payload);
    }

    getById(id: number | string): Observable<any> {
        return this.api.get(`hr/employee/show/${id}`);
    }

    update(id: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/update/${id}`, payload);
    }

    uploadPhoto(id: number | string, formData: FormData): Observable<any> {
        return this.api.post(`hr/employee/photo/${id}`, formData);
    }

    terminate(id: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/termination/${id}`, payload);
    }

    uploadDocument(employeeId: number | string, formData: FormData): Observable<any> {
        return this.api.post(`hr/employee/${employeeId}/document/upload`, formData);
    }

    deleteDocument(employeeId: number | string, type: string): Observable<any> {
        return this.api.delete(`hr/employee/${employeeId}/document/${type}`);
    }

    /**
     * Convierte la ruta cruda almacenada por el backend (ej. "public/documents/foo.pdf")
     * en una URL accesible desde el navegador, igual que getPhotoUrl.
     */
    getDocumentUrl(filePath: any): string | null {
        if (!filePath) return null;
        const cleanPath = String(filePath).replace(/^public\//, '');
        return `${environment.url_page}/storage/${cleanPath}`;
    }

    /**
     * Convierte la ruta cruda almacenada por el backend (ej. "public/images/foo.jpg")
     * en una URL accesible desde el navegador (ej. "http://host/storage/images/foo.jpg").
     */
    getPhotoUrl(photo: any): string | null {
        if (!photo) return null;
        const cleanPath = String(photo).replace(/^public\//, '');
        return `${environment.url_page}/storage/${cleanPath}`;
    }
}
